import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { SourceRowsCustomValidationsParams } from './customValidations.types';
import { SOURCE_ROW_PRICE, SOURCE_ROW_WEIGHTING, SOURCE_TOTALS_ROW } from './sheetAliases';

const TOTAL_WEIGHTING_ERROR = 'Total weighting must equal 100%';
const TOTALS_WEIGHTING_ALIAS = `${SOURCE_TOTALS_ROW}_weighting`;

const hasNonZeroWeight = (c: ICell): boolean => Number(c.value ?? 0) !== 0;

const customValidations = ({
  cell,
  parsedColumns,
  addFeedbackFromCell,
  removeFeedbackFromCell,
}: SourceRowsCustomValidationsParams): void => {
  const isWeightingCell = cell.alias?.startsWith(SOURCE_ROW_WEIGHTING);
  const isPriceCell = cell.alias?.startsWith(SOURCE_ROW_PRICE);
  if (!isWeightingCell && !isPriceCell) {
    return;
  }

  const weightingCells = Object.values(parsedColumns).filter(
    (c: ICell) => c.alias?.startsWith(SOURCE_ROW_WEIGHTING) && !c.readOnly
  );
  const totalsWeightingCell = Object.values(parsedColumns).find(
    (c: ICell) => c.alias === TOTALS_WEIGHTING_ALIAS
  );
  const allFeedbackCells = totalsWeightingCell ? [...weightingCells, totalsWeightingCell] : weightingCells;

  // Values are stored as decimals (e.g. 0.5 = 50%)
  const total = weightingCells.reduce((sum: number, c: ICell) => sum + Number(c.value ?? 0), 0);

  const hasAnyNonZeroPrice = Object.values(parsedColumns).some(
    (c: ICell) => c.alias?.startsWith(SOURCE_ROW_PRICE) && Number(c.value ?? 0) !== 0
  );

  const clearWeightingError = (c: ICell) => {
    const keepsHavingError = (c.tooltipMessages ?? []).some((m: string) => m !== TOTAL_WEIGHTING_ERROR);
    removeFeedbackFromCell(c, TOTAL_WEIGHTING_ERROR, 'error', keepsHavingError);
  };

  if ((total > Number.EPSILON || hasAnyNonZeroPrice) && Math.abs(total - 1) > Number.EPSILON) {
    weightingCells.filter(hasNonZeroWeight).forEach((c: ICell) => {
      addFeedbackFromCell(c, TOTAL_WEIGHTING_ERROR);
    });
    weightingCells.filter(c => !hasNonZeroWeight(c)).forEach(clearWeightingError);
    if (totalsWeightingCell) {
      addFeedbackFromCell(totalsWeightingCell, TOTAL_WEIGHTING_ERROR);
    }
  } else {
    allFeedbackCells.forEach(clearWeightingError);
  }
};

export default customValidations;
